import * as e from "react";
import { forwardRef as l } from "react";
const i = l(
  function(C, t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: t,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...C
      },
      /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7.15723 11.6562V12.5H2.86816V11.7749L4.95117 9.50293C5.17969 9.24512 5.35986 9.02246 5.4917 8.83496C5.62354 8.64746 5.71582 8.479 5.76855 8.32959C5.82422 8.17725 5.85205 8.0293 5.85205 7.88574C5.85205 7.68359 5.81396 7.50635 5.73779 7.354C5.66455 7.19873 5.55615 7.07715 5.4126 6.98926C5.26904 6.89844 5.09473 6.85303 4.88965 6.85303C4.65234 6.85303 4.45312 6.9043 4.29199 7.00684C4.13086 7.10938 4.00928 7.25146 3.92725 7.43311C3.84521 7.61182 3.8042 7.81689 3.8042 8.04834H2.74512C2.74512 7.67627 2.83008 7.33643 3 7.02881C3.16992 6.71826 3.41602 6.47217 3.73828 6.29053C4.06055 6.10596 4.44873 6.01367 4.90283 6.01367C5.33057 6.01367 5.69385 6.08545 5.99268 6.229C6.2915 6.37256 6.51855 6.57617 6.67383 6.83984C6.83203 7.10352 6.91113 7.41553 6.91113 7.77588C6.91113 7.9751 6.87891 8.17285 6.81445 8.36914C6.75 8.56543 6.65771 8.76172 6.5376 8.95801C6.42041 9.15137 6.28125 9.34619 6.12012 9.54248C5.95898 9.73584 5.78174 9.93213 5.58838 10.1313L4.2041 11.6562H7.15723ZM12.1538 8.76465V9.81055C12.1538 10.3115 12.104 10.7393 12.0044 11.0938C11.9077 11.4453 11.7671 11.731 11.5825 11.9507C11.3979 12.1704 11.1768 12.3315 10.9189 12.4341C10.6641 12.5366 10.3784 12.5879 10.062 12.5879C9.81006 12.5879 9.57568 12.5557 9.35889 12.4912C9.14502 12.4268 8.95166 12.3257 8.77881 12.188C8.60596 12.0503 8.45801 11.873 8.33496 11.6562C8.21484 11.4365 8.12109 11.1743 8.05371 10.8696C7.98926 10.5649 7.95703 10.2119 7.95703 9.81055V8.76465C7.95703 8.26074 8.00684 7.83594 8.10645 7.49023C8.20605 7.1416 8.34814 6.85889 8.53271 6.64209C8.71729 6.42236 8.93701 6.2627 9.19189 6.16309C9.44971 6.06348 9.73682 6.01367 10.0532 6.01367C10.3081 6.01367 10.5425 6.0459 10.7563 6.11035C10.9731 6.17188 11.1665 6.27002 11.3364 6.40479C11.5093 6.53955 11.6558 6.71533 11.7759 6.93213C11.8989 7.146 11.9927 7.40527 12.0571 7.70996C12.1216 8.01172 12.1538 8.36328 12.1538 8.76465ZM11.0947 9.95996V8.60645C11.0947 8.35156 11.0801 8.12744 11.0508 7.93408C11.0215 7.73779 10.9775 7.57227 10.9189 7.4375C10.8633 7.2998 10.793 7.18848 10.708 7.10352C10.623 7.01562 10.5264 6.95264 10.418 6.91455C10.3096 6.87354 10.188 6.85303 10.0532 6.85303C9.88916 6.85303 9.74268 6.88525 9.61377 6.94971C9.48486 7.01123 9.37646 7.11084 9.28857 7.24854C9.20068 7.38623 9.1333 7.56787 9.08643 7.79346C9.04248 8.01611 9.02051 8.28711 9.02051 8.60645V9.95996C9.02051 10.2178 9.03516 10.4448 9.06445 10.6411C9.09375 10.8374 9.1377 11.0059 9.19629 11.1465C9.25488 11.2842 9.3252 11.3984 9.40723 11.4893C9.49219 11.5771 9.58887 11.6416 9.69727 11.6826C9.80859 11.7236 9.93018 11.7441 10.062 11.7441C10.229 11.7441 10.377 11.7119 10.5059 11.6475C10.6348 11.583 10.7432 11.4805 10.8311 11.3398C10.9189 11.1963 10.9849 11.0103 11.0288 10.7817C11.0728 10.5532 11.0947 10.2793 11.0947 9.95996Z",
          fill: "#000"
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M16.2744 8.99414V9.93164H13.6914V8.99414H16.2744Z",
          fill: "#000"
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M21.6753 6.10156V6.68164L19.1177 12.5H18.0015L20.5547 6.94531H17.2412V6.10156H21.6753Z",
          fill: "#000"
        }
      )),
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          height: 16.5,
          rx: 2.25,
          stroke: "#000",
          strokeWidth: 1.5,
          width: 22.5,
          x: 0.75,
          y: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "line",
        {
          stroke: "#000",
          strokeWidth: 1.5,
          x1: 4.75,
          x2: 4.75,
          y1: 17,
          y2: 24
        }
      ),
      /* @__PURE__ */ e.createElement(
        "line",
        {
          stroke: "#000",
          strokeWidth: 1.5,
          x1: 19.25,
          x2: 19.25,
          y1: 17,
          y2: 24
        }
      ),
      /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 18, rx: 3, width: 24 })))
    );
  }
);
export {
  i as BetBuilderBadgeAmericanResult
};
